import { CircularProgress, CircularProgressProps } from '@mui/material';
import clsx from 'clsx';

import { mergeSx } from '../../../utils';

export type SpinnerProps = CircularProgressProps & {
  noBackground?: boolean;
  testId?: string;
};

export const Spinner = ({
  className,
  noBackground,
  size,
  sx,
  testId,
  ...rest
}: SpinnerProps) => {
  return (
    <CircularProgress
      disableShrink
      thickness={4}
      className={clsx(
        'DS-Spinner-root',
        !noBackground && 'DS-Spinner-withBackground',
        className
      )}
      size="1em"
      sx={mergeSx(
        {
          fontSize: size,
        },
        sx
      )}
      data-testid={testId}
      {...rest}
    />
  );
};
